'use strict';
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.aggregate-error.constructor');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/es.aggregate-error.js
// module id = 269
// module chunks = 13